<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>ຫ້ອງ</h4>
            <h6>ຈັດການຫ້ອງ</h6>
          </div>
        </div>
        <div class="page-btn">
          <a
            href="javascript:void(0);"
            class="btn btn-added"
            data-bs-toggle="modal"
            data-bs-target="#add-category"
            ><vue-feather type="plus-circle" class="me-2"></vue-feather> ເພີ່ມຫ້ອງ</a
          >
        </div>
      </div>

      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input type="text" placeholder="ຄົ້ນຫາ" class="dark-input" v-model="searchQuery" @input="handleSearch" />
                <a href="" class="btn btn-searchset"
                  ><i data-feather="search" class="feather-search"></i
                ></a>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <a-table
              class="table datanew table-hover table-center mb-0"
              :columns="columns"
              :data-source="filteredData"
              :pagination="{ pageSize: 10, simple: true, hideOnSinglePage: true }"
              :loading="loading"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <a
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#edit-category"
                        @click="openEditModal(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a
                        class="confirm-text p-2"
                        @click="showConfirmation(record)"
                        href="javascript:void(0);"
                      >
                        <i data-feather="trash-2" class="feather-trash-2"></i>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <sub-categories-modal 
    ref="subCategoriesModal"
    @create-category="createCategory" 
    @update-category="updateCategory"
  ></sub-categories-modal>
</template>
<script>
import classService from '@/services/class.service';

const columns = [
  {
    title: "ຫ້ອງ",
    dataIndex: "Category",
    sorter: {
      compare: (a, b) => {
        a = a.Category.toLowerCase();
        b = b.Category.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "ປີ",
    dataIndex: "Year",
    sorter: {
      compare: (a, b) => {
        a = a.Year.toString();
        b = b.Year.toString();
        return a > b ? 1 : b > a ? -1 : 0;
      },
    },
  },
  {
    title: "ສ້າງໂດຍ",
    dataIndex: "CreatedBy",
    sorter: {
      compare: (a, b) => {
        a = a.CreatedBy.toLowerCase();
        b = b.CreatedBy.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "ຈັດການ",
    key: "action",
    sorter: true,
  },
];

export default {
  data() {
    return {
      filter: false,
      searchQuery: "",
      data: [],
      filteredData: [],
      columns,
      loading: false,
      selectedCategory: null,
      currentCategory: null
    };
  },
  created() {
    this.fetchCategories();
  },
  methods: {
    handleSearch() {
      if (!this.searchQuery) {
        this.filteredData = this.data;
        return;
      }
      const query = this.searchQuery.toLowerCase();
      this.filteredData = this.data.filter(item => 
        item.Category.toLowerCase().includes(query) ||
        (item.Year && item.Year.toString().toLowerCase().includes(query)) ||
        item.CreatedBy.toLowerCase().includes(query)
      );
    },
    fetchCategories() {
      this.loading = true;
      classService.getAllClasses()
        .then(response => {
          this.data = response.data.map(item => ({
            id: item.id,
            Category: item.name,
            Year: item.year,
            CreatedBy: item.createdBy || "Admin"
          }));
          this.filteredData = this.data;
        })
        .catch(error => {
          console.error('Error fetching categories:', error);
          this.loadStaticData();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    loadStaticData() {
      this.data = [
        {
          Category: "Computers",
          Year: 2023,
          CreatedBy: "Admin",
          id: 1
        },
      ];
      this.filteredData = this.data;
    },
    
    createCategory(categoryData) {
      this.loading = true;
      classService.createClass({
        name: categoryData.name,
        year: categoryData.year
      })
        .then(response => {
          const newCategory = response.data;
          this.data.unshift({
            id: newCategory.id,
            Category: newCategory.name,
            Year: newCategory.year,
            CreatedBy: newCategory.createdBy || "Admin"
          });
          this.filteredData = this.data;
          
          this.$swal({
            icon: 'success',
            title: 'ສຳເລັດ!',
            text: 'ສ້າງສຳເລັດແລ້ວ',
            confirmButtonClass: 'btn btn-success'
          });
        })
        .catch(error => {
          console.error('Error creating category:', error);
          this.$swal({
            icon: 'error',
            title: 'ຜິດພາດ!',
            text: 'ບໍ່ສາມາດສ້າງຫ້ອງໄດ້',
            confirmButtonClass: 'btn btn-danger'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    updateCategory(id, categoryData) {
      this.loading = true;
      classService.updateClass(id, {
        name: categoryData.name,
        year: categoryData.year
      })
        .then(response => {
          const updatedCategory = response.data;
          const index = this.data.findIndex(item => item.id === id);
          if (index !== -1) {
            this.data[index] = {
              id: updatedCategory.id,
              Category: updatedCategory.name,
              Year: updatedCategory.year,
              CreatedBy: updatedCategory.createdBy || this.data[index].CreatedBy
            };
            this.filteredData = this.data;
          }
          
          this.$swal({
            icon: 'success',
            title: 'ສຳເລັດ!',
            text: 'ອັບເດດຫ້ອງສຳເລັດແລ້ວ',
            confirmButtonClass: 'btn btn-success'
          });
        })
        .catch(error => {
          console.error('Error updating category:', error);
          this.$swal({
            icon: 'error',
            title: 'ຜິດພາດ!',
            text: 'ບໍ່ສາມາດອັບເດດຫ້ອງໄດ້',
            confirmButtonClass: 'btn btn-danger'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    deleteCategory(id) {
      classService.deleteClass(id)
        .then(() => {
          this.data = this.data.filter(item => item.id !== id);
          this.filteredData = this.data;
          
          this.$swal({
            icon: 'success',
            title: 'ລຶບແລ້ວ!',
            text: 'ຫ້ອງຖືກລຶບແລ້ວ.',
            confirmButtonClass: 'btn btn-success'
          });
        })
        .catch(error => {
          console.error('Error deleting category:', error);
          this.$swal({
            icon: 'error',
            title: 'ຜິດພາດ!',
            text: 'ບໍ່ສາມາດລຶບຫ້ອງໄດ້',
            confirmButtonClass: 'btn btn-danger'
          });
        });
    },
    
    openEditModal(category) {
      this.currentCategory = category;
      this.$nextTick(() => {
        if (this.$refs.subCategoriesModal) {
          this.$refs.subCategoriesModal.setEditCategory(category);
        } else {
          console.error('Modal reference not found');
        }
      });
    },
    
    showConfirmation(record) {
      this.selectedCategory = record;
      this.$swal({
        title: "ທ່ານແນ່ໃຈບໍ?",
        text: "ທ່ານຈະບໍ່ສາມາດກູ້ຄືນໄດ້!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ແມ່ນ, ລຶບອອກ!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value && this.selectedCategory) {
          this.deleteCategory(this.selectedCategory.id);
        }
      });
    },
  },
};
</script>
